import React from 'react';
import EylulGerceklesen from './EylulGerceklesen';

/**
 * Keramet Ilıcası — Eylül 2026 medya planı (tam plan, kampanya kırılımlı).
 * Kardeş sayfalar: KixxEylul2026MedyaPlani, HupalupaEglenceEylul2026MedyaPlani.
 *
 * 🔑 Bütçe Efe'nin kararı: ₺70.000 (slayt sürümü ₺120.000 öneriyordu).
 * Ağustos kapanışı ₺189.358 → Eylül -%63.
 *
 * 🔑🔑 Kesintinin gerekçesi sezon. TESİSİN SATTIĞI kelimelerden oluşan sepet
 * Ağustos→Eylül İKİ YIL DA -%39 (103.590→62.790 ve 106.690→65.190).
 * Yani Eylül harcanacak ay değil, sezona para biriktirilecek ay.
 *
 * 🔴🔴 1 Eylül revizyonu (Efe): KONAKLAMA KELİMESİ HEDEFLENMEYECEK.
 * `termal otel` / `kaplıca otelleri` / `termal tatil` Eylül'de +%22 artıyor
 * ama tesis konaklama satmıyor; o talep bizim değil. İki arama kampanyası
 * (marka ₺10.000 + konaklama ₺10.000) TEK kampanyada birleştirildi, ₺20.000:
 * keramet ılıcası + ılıca + kaplıca + bursa kaplıca + termal su/havuz.
 * Gerekçe: marka sorgusu tek başına ₺10.000 harcayamaz, jenerik günübirlik
 * kelimelerle aynı kampanyada olması gerekiyor.
 *
 * 🔴🔴 Bu hesapta ÖLÇÜLEBİLİR SONUÇ YOK. Google Arama Ağustos'ta ₺13.538
 * harcadı, 1.409 tık getirdi, DÖNÜŞÜM SIFIR. Meta'nın tamamı awareness,
 * Ağustos'ta yalnızca 6 mesaj. Bu yüzden hiçbir tabloda lead/rezervasyon
 * projeksiyonu YOK; ay sonu ölçütü kurulumun kendisidir.
 *
 * Ağustos rakamları 1 Eylül 2026'da, ay kapandıktan sonra çekildi:
 *  · Meta   → Graph API act_2095088354756210, kampanya seviyesi insights.
 *  · Google → fetch_google_ads_campaign_insights_live.py, müşteri 6654294370.
 * Arama hacimleri: Keyword Planner, geo Türkiye (2792), dil TR (1000),
 * network GOOGLE_SEARCH, çekim 1 Eyl 2026.
 */

/* Gerçekleşen bölümünün plana bakacağı mecra bütçeleri; aşağıdaki plan
   tablosuyla AYNI rakamlar (Google 28.000 + Meta 42.000). Tabloyu değiştirirsen burayı da değiştir. */
export const BRAND_ID = 'd57a0a98-b47c-45d5-ae2e-ff0fc265f270';
export const MECRA_PLANI = { GOOGLE_ADS: 28000, META_ADS: 42000 };

const AMAC_STIL = {
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
  'Trafik': 'bg-sky-50 text-sky-700 border-sky-200',
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

function Amac({ tip, not }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}{not ? ` (${not})` : ''}
    </span>
  );
}

export default function KerametIlicasiEylul2026MedyaPlani() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-white border border-gray-200 px-3 py-2">
              <img src="/logos/grup/keramet.png" alt="Keramet Ilıcası" className="h-7 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">Keramet Ilıcası Eylül 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Termal tesis, Bursa · günübirlik ve konaklama · Meta (Erişim + DM) · Google (Arama + YouTube)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              1 - 30 Eylül 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Toplam: ₺70.000
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* Eylül odağı */}
          <div className="mb-6 p-4 rounded-xl bg-cyan-50 border border-cyan-200">
            <p className="text-xs font-semibold text-cyan-800 mb-1">Eylül odağı: sezon öncesi hazırlık ayı</p>
            <p className="text-[11px] text-cyan-700 leading-relaxed">
              Eylül, bu tesis için harcanacak ay değil. Tesisin gerçekten sattığı şeyi arayan kelimeler,
              yani günübirlik kaplıca ve ılıca sorguları, Ağustos'tan Eylül'e iki yıl üst üste yaklaşık
              yüzde kırk düşüyor. Havalar döndükçe günübirlik kullanım fikri geri çekiliyor.
              Bu yüzden Ağustos'ta harcanan ₺189.358 Eylül'de ₺70.000'e iniyor.
              Aynı dönemde artan tek grup konaklama sorguları: "termal otel" ve "kaplıca otelleri" Eylül'de
              yüzde yirmi iki büyüyor. Ama tesis konaklama satmıyor, o talep bizim değil. Bu kelimeler bilerek
              hedeflenmiyor; hedeflenseydi tıklama gelir, karşılığı gelmezdi.
              Eylül'ün işi hacim değil hazırlık. İki şey yapılıyor: aramadaki dağınık yapı tek kampanyada
              toplanıyor, ve bugüne kadar hiç kurulmamış olan rezervasyon ölçümü devreye alınıyor.
              Ekim'e ölçüm olmadan girilirse sonraki ayların tamamı kör harcanır.
            </p>
          </div>

          {/* Arama talebi */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">
              Tesisin sattığı kelimelerde talep Eylül'de yüzde kırk düşüyor
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 p-4">
              <div className="rounded-lg border border-rose-100 bg-rose-50 p-3">
                <p className="text-[10px] font-medium text-rose-700">Eylül 2025, Ağustos'a göre</p>
                <p className="text-lg font-bold text-rose-800 mt-0.5">-%39</p>
                <p className="text-[10px] text-rose-600">103.590 → 62.790 arama/ay</p>
              </div>
              <div className="rounded-lg border border-rose-100 bg-rose-50 p-3">
                <p className="text-[10px] font-medium text-rose-700">Eylül 2024, Ağustos'a göre</p>
                <p className="text-lg font-bold text-rose-800 mt-0.5">-%39</p>
                <p className="text-[10px] text-rose-600">106.690 → 65.190 arama/ay</p>
              </div>
              <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-3">
                <p className="text-[10px] font-medium text-emerald-700">Marka talebi, yıllık</p>
                <p className="text-lg font-bold text-emerald-800 mt-0.5">5,1 kat</p>
                <p className="text-[10px] text-emerald-600">"keramet ılıcası" Tem 2025: 2.900 · Tem 2026: 14.800</p>
              </div>
              <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
                <p className="text-[10px] font-medium text-gray-600">Hedeflenmeyen talep</p>
                <p className="text-lg font-bold text-gray-800 mt-0.5">+%22</p>
                <p className="text-[10px] text-gray-500">konaklama sorguları · tesis konaklama satmıyor</p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Kelime</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu 2025</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eyl 2025</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu 2024</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eyl 2024</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr className="bg-slate-100/70">
                    <td className="px-4 py-1.5 font-semibold text-gray-700 text-[10px] uppercase tracking-wider" colSpan={7}>Hedeflenen kelimeler</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">keramet ılıcası <span className="text-[10px] text-gray-400">marka</span></td>
                    <td className="px-4 py-2 text-right">1.900</td>
                    <td className="px-4 py-2 text-right">1.000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%47</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">1.600</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%45</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">ılıca</td>
                    <td className="px-4 py-2 text-right">60.500</td>
                    <td className="px-4 py-2 text-right">33.100</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%45</td>
                    <td className="px-4 py-2 text-right">60.500</td>
                    <td className="px-4 py-2 text-right">33.100</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%45</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">kaplıca</td>
                    <td className="px-4 py-2 text-right">33.100</td>
                    <td className="px-4 py-2 text-right">22.200</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%33</td>
                    <td className="px-4 py-2 text-right">33.100</td>
                    <td className="px-4 py-2 text-right">22.200</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%33</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">bursa kaplıca</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                    <td className="px-4 py-2 text-right">3.600</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%19</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">termal su</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">1.900</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%34</td>
                    <td className="px-4 py-2 text-right">3.600</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%33</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">termal havuz</td>
                    <td className="px-4 py-2 text-right">1.900</td>
                    <td className="px-4 py-2 text-right">1.300</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%32</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">kaplıca tatili</td>
                    <td className="px-4 py-2 text-right">390</td>
                    <td className="px-4 py-2 text-right">390</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                    <td className="px-4 py-2 text-right">590</td>
                    <td className="px-4 py-2 text-right">590</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Hedeflenen sepet (7 kelime)</td>
                    <td className="px-4 py-2 text-right">103.590</td>
                    <td className="px-4 py-2 text-right">62.790</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%39</td>
                    <td className="px-4 py-2 text-right">106.690</td>
                    <td className="px-4 py-2 text-right">65.190</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%39</td>
                  </tr>

                  <tr className="bg-slate-100/70">
                    <td className="px-4 py-1.5 font-semibold text-gray-500 text-[10px] uppercase tracking-wider" colSpan={7}>Hedeflenmeyen kelimeler, tesis konaklama satmıyor</td>
                  </tr>
                  <tr className="text-gray-400">
                    <td className="px-4 py-2 font-medium">termal otel</td>
                    <td className="px-4 py-2 text-right">33.100</td>
                    <td className="px-4 py-2 text-right">40.500</td>
                    <td className="px-4 py-2 text-right">+%22</td>
                    <td className="px-4 py-2 text-right">40.500</td>
                    <td className="px-4 py-2 text-right">40.500</td>
                    <td className="px-4 py-2 text-right">%0</td>
                  </tr>
                  <tr className="text-gray-400">
                    <td className="px-4 py-2 font-medium">kaplıca otelleri</td>
                    <td className="px-4 py-2 text-right">5.400</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right">+%22</td>
                    <td className="px-4 py-2 text-right">6.600</td>
                    <td className="px-4 py-2 text-right">8.100</td>
                    <td className="px-4 py-2 text-right">+%23</td>
                  </tr>
                  <tr className="text-gray-400">
                    <td className="px-4 py-2 font-medium">termal tatil</td>
                    <td className="px-4 py-2 text-right">590</td>
                    <td className="px-4 py-2 text-right">720</td>
                    <td className="px-4 py-2 text-right">+%22</td>
                    <td className="px-4 py-2 text-right">720</td>
                    <td className="px-4 py-2 text-right">720</td>
                    <td className="px-4 py-2 text-right">%0</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700 leading-relaxed">
              Tablo bilerek ikiye ayrıldı. Üstteki yedi kelime tesisin gerçekten sattığı şeyi arayan sorgular ve
              hepsi Eylül'de düşüyor; sepet iki yıl da yüzde otuz dokuz küçülüyor. Bütçenin ₺70.000'e inmesinin
              tek gerekçesi bu.
              Alttaki üç kelime Eylül'de artan tek grup, ama konaklama arıyorlar. Tesiste konaklama olmadığı için
              bu kelimeler kampanyaya girmiyor. Girseydi tıklama gelirdi, gelen kişi aradığını bulamazdı ve para
              tıklama başına ödenmiş olurdu. Buraya konmalarının sebebi hedeflenmek değil, hedeflenmediklerinin
              yazılı olması.
              Marka sorgusu "keramet ılıcası" mevsimsel olarak Eylül'de düşüyor, ama yıllık bazda bambaşka bir
              yerde: Temmuz 2025'te 2.900 iken Temmuz 2026'da 14.800. Ağustos'ta harcanan para bu talebi yarattı.
              Kaynak Google Ads Keyword Planner, Türkiye, Türkçe, yalnızca Google Arama (Arama Ortakları hariç).
            </div>
          </div>

          {/* Ön koşul */}
          <div className="mb-6 rounded-xl border-2 border-rose-300 bg-rose-50 p-4">
            <p className="text-xs font-semibold text-rose-900 mb-1">Bu ayın asıl işi: ölçüm kurmak</p>
            <p className="text-[11px] text-rose-800 leading-relaxed">
              Bu hesapta bugün ölçülebilir tek sonuç erişim. Google Arama Ağustos'ta ₺13.538 harcadı,
              1.409 tıklama getirdi, hesapta <strong>sıfır dönüşüm</strong> kayıtlı. Meta tarafının tamamı
              awareness hedefiyle çalışıyor ve ay boyunca yalnızca 6 mesaj üretti.
              Yani iki aydır ne kaç rezervasyon geldiğini, ne bir rezervasyonun kaça mal olduğunu biliyoruz.
              Eylül'de yapılacak üç kurulum, sırayla:
              site üzerinde rezervasyon formu ve telefon tıklamasının dönüşüm olarak tanımlanması,
              Meta tarafında mesaj hedefli bir kampanyanın açılıp konuşma başına maliyetin ölçülmeye başlaması,
              ve tesise gelen misafirin nereden geldiğinin resepsiyonda kayda alınması.
              Aramada tek kampanya çalışacağı için arama terimleri raporu bu ayın en önemli çıktısı olacak:
              hangi sorgunun gerçekten ziyarete döndüğünü ilk kez oradan göreceğiz.
              Bu üçü 15 Eylül'e kadar tamamlanmazsa Ekim'in sezon bütçesi artırılmaz. Ölçümü olmayan bir hesapta
              bütçeyi büyütmek, sezonun tamamını değerlendirilemez hale getirir.
            </p>
          </div>

          {/* Ağustos gerçekleşen → Eylül plan */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Ağustos 2026 gerçekleşen ve Eylül 2026 planı</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos birim maliyet</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Ağustos sonucu</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül planı</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">Meta Ads</td>
                    <td className="px-4 py-2 text-right">₺172.912</td>
                    <td className="px-4 py-2 text-right">₺8,79 CPM · ₺4,43 CPC</td>
                    <td className="px-4 py-2">8,37M erişim · 1,45M video izlenme · <span className="text-rose-600">6 mesaj</span></td>
                    <td className="px-4 py-2 text-right font-semibold">₺42.000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%76</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">Google Arama</td>
                    <td className="px-4 py-2 text-right">₺13.538</td>
                    <td className="px-4 py-2 text-right">₺9,61 CPC</td>
                    <td className="px-4 py-2">17.688 gösterim · 1.409 tık · <span className="text-rose-600">sıfır ölçülü dönüşüm</span></td>
                    <td className="px-4 py-2 text-right font-semibold">₺20.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%48</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">YouTube</td>
                    <td className="px-4 py-2 text-right">₺2.908</td>
                    <td className="px-4 py-2 text-right">₺22,47 CPM</td>
                    <td className="px-4 py-2">129.415 gösterim</td>
                    <td className="px-4 py-2 text-right font-semibold">₺8.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%175</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">₺189.358</td>
                    <td className="px-4 py-2 text-right">-</td>
                    <td className="px-4 py-2">yalnızca erişim ölçülebiliyor</td>
                    <td className="px-4 py-2 text-right">₺70.000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%63</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700">
              Kesinti tamamen Meta'dan geliyor. Ağustos'ta Meta bütçenin %91'iydi ve karşılığında 8,37 milyon
              kişiye ulaşıldı, ancak bu erişimin kaç kişiyi tesise getirdiği ölçülmedi.
              Aramanın payı %7'den %29'a çıkıyor. Aramada kim ne aradığı belli, bu yüzden ölçüm kurulur kurulmaz
              ilk anlamlı veri oradan gelecek.
            </div>
          </div>

          {/* Amaç bazlı dağılım */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya amacına göre bütçe dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-red-400" style={{ width: '54.3%' }} title="Farkındalık %54" />
                <div className="bg-emerald-400" style={{ width: '45.7%' }} title="Dönüşüm %46" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Kampanyalar</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺38.000</td>
                    <td className="px-4 py-2.5 text-right">%54,3</td>
                    <td className="px-4 py-2.5">Meta erişim (₺30.000) · YouTube erişim (₺8.000)</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" not="mesaj ve arama" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺32.000</td>
                    <td className="px-4 py-2.5 text-right">%45,7</td>
                    <td className="px-4 py-2.5">Google Arama tek kampanya (₺20.000) · Meta mesaj (₺12.000)</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺70.000</td>
                    <td className="px-4 py-2.5 text-right">%100</td>
                    <td className="px-4 py-2.5">2 mecra · 4 kampanya</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-800">
              Ağustos'ta ölçülebilir sonuç hedefleyen kampanyaların payı %7'ydi, tamamı arama tarafındaydı.
              Eylül'de bu pay %46'ya çıkıyor. Bütçe küçülürken ölçülebilir kısım büyüyor; ayın amacı zaten bu.
            </div>
          </div>

          {/* Bütçe kartları */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺42.000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">%60 · erişim ₺30.000 + mesaj ₺12.000</p>
            </div>
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺28.000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">%40 · Arama ₺20.000 + YouTube ₺8.000</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı, Keramet Ilıcası Eylül 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">

                  {/* Meta */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={2}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Farkındalık, geniş erişim</td>
                    <td className="px-4 py-3">Bursa ve komşu iller, 28-55 yaş</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺30.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Mesaj, <strong>rezervasyon</strong> <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">Video izleyicileri ve sayfa etkileşimcileri</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="mesaj" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺12.000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺42.000</td>
                  </tr>

                  {/* Google */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={2}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Arama, <strong>marka ve kategori</strong></td>
                    <td className="px-4 py-3">keramet ılıcası, ılıca, kaplıca, bursa kaplıca, termal su, termal havuz, kaplıca tatili</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺20.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">YouTube, erişim</td>
                    <td className="px-4 py-3">Bursa ve komşu iller, tatil ve wellness ilgisi</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺8.000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺28.000</td>
                  </tr>

                  {/* Kapatilan */}
                  <tr className="bg-rose-50/60 text-gray-500">
                    <td className="px-4 py-3 font-medium">Meta Ads</td>
                    <td className="px-4 py-3">Farkındalık, kopya kampanya</td>
                    <td className="px-4 py-3" colSpan={2}>Ana kampanyanın kopyası. ₺30.000'lik bütçeyi ikiye bölmenin anlamı yok, tek kampanyada birleştiriliyor.</td>
                    <td className="px-4 py-3 text-right font-medium">₺0</td>
                  </tr>

                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3 text-right">₺70.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Plan ↔ gerçekleşen; mecralardan canlı okunur (bkz. EylulGerceklesen). */}
          <EylulGerceklesen
            brandId={BRAND_ID}
            plan={MECRA_PLANI}
            kpi="reach"
            notlar="Bu hesapta ölçülebilir dönüşüm tanımlı değil; sonuç sütunu yerine erişim tarafındaki gösterim ve video izlenme yazılır."
          />

          {/* Uygulama notları */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Uygulama notları</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-5 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Aramada tek kampanya, ayrı reklam grupları</p>
                <p className="leading-relaxed">
                  Marka sorgusu "keramet ılıcası" Temmuz 2026'da 14.800 aylık aramaya ulaştı, bir yıl önce 2.900'dü.
                  Bu talep Ağustos'ta harcanan parayla yaratıldı. Yine de marka tek başına ₺10.000'lik ayrı bir
                  kampanyayı doldurmaz; Eylül'de marka sorgusu kendi mevsiminde de düşüyor.
                  Bu yüzden marka ve kategori aynı kampanyada, ayrı reklam gruplarında çalışacak. Kampanya bütçesi
                  ortak, ama grup ayrımı sayesinde marka tıklamasının mı kategori tıklamasının mı ziyarete
                  döndüğü ay sonunda ayrı ayrı görülebilecek.
                  Ağustos'ta aramaya ₺13.538 gitmişti; ₺20.000 bu hacmin doğal bir devamı, sıçrama değil.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Konaklama kelimeleri neden alınmıyor</p>
                <p className="leading-relaxed">
                  Eylül'de artan tek grup konaklama sorguları: "termal otel" 40.500, "kaplıca otelleri" 6.600
                  aylık aramaya çıkıyor. Bu hacim çekici görünür ve bu kelimeleri kampanyaya eklemek kolaydır.
                  Ancak tesiste konaklama yok. Otel arayan kişi tıklar, sayfada aradığını bulamaz, geri döner;
                  para yine de ödenmiş olur. Üstelik bu kelimeler otel zincirlerinin yarıştığı kelimeler,
                  tıklama maliyeti günübirlik sorgulardan yüksek.
                  Bu yüzden üçü de kampanyaya girmiyor ve negatif listeye ekleniyor. Tesise konaklama eklenirse
                  bu karar yeniden değerlendirilir.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Erişim ucuz ama tek başına yeterli değil</p>
                <p className="leading-relaxed">
                  Meta tarafında bin gösterim maliyeti ₺8,79. Bu çok düşük bir rakam ve Ağustos'ta 8,37 milyon
                  kişiye ulaşılmasını sağladı. Ancak awareness hedefiyle çalışan bir kampanya insanları en ucuz
                  gösterimi veren yerleşimlere taşır, tıklama ya da mesaj üretmeye çalışmaz.
                  Eylül'de erişim ₺30.000'e iniyor ve yanına ₺12.000'lik mesaj hedefli bir kampanya geliyor.
                  İkincisinin bin gösterim maliyeti kat kat yüksek olacak; kıyaslanacak şey gösterim maliyeti değil,
                  konuşma başına maliyet.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Kopya kampanya birleştiriliyor</p>
                <p className="leading-relaxed">
                  Ağustos'ta iki awareness kampanyası paralel çalıştı: ana kampanya ₺129.631, kopyası ₺43.281.
                  İkisi de aynı kitleye aynı mesajı gösteriyor ve birbirinin teklifini yükseltiyor.
                  ₺30.000'lik bir bütçeyi ikiye bölmek her iki kampanyanın da öğrenme aşamasından çıkmasını
                  engeller. Eylül'de tek kampanya çalışacak.
                </p>
              </div>
            </div>
          </div>

          {/* Veri notu */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Veri notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Ağustos rakamları ay kapandıktan sonra, 1 Eylül 2026'da canlı API'lerden çekildi.
                  Meta tarafı act_2095088354756210, Google tarafı müşteri 6654294370.
                  Arama kelimeleri tesisin sattığı hizmete göre seçildi. Konaklama sorguları hacimli olmalarına
                  rağmen bilerek dışarıda bırakıldı ve negatif listeye alınacak.
                  Bu sayfada rezervasyon, lead ya da ciro projeksiyonu bilerek verilmedi. Hesapta tanımlı bir
                  dönüşüm olmadığı için tıklamadan rezervasyona geçiş oranı bilinmiyor; sayı vermek uydurma olur.
                  Ağustos ile Temmuz kıyaslanabilir değil: Temmuz'da Meta harcaması ₺32.062'ydi ve Google hesabı
                  hiç çalışmıyordu, Ağustos beş katından fazla bir sıçramaydı.
                  Erişim rakamları platform içi tekildir, Meta ile Google arasındaki çakışma ölçülemez.
                  Arama hacimleri Google Ads Keyword Planner'dan Türkiye ve Türkçe kırılımıyla alındı.
                  Planner değerleri aralık ortalamasıdır, bu yüzden pek çok kelimede değişim aynı orana denk gelir.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}
